var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1514",
    "data-name": "Rectangle 1514",
    width: 24,
    height: 24,
    transform: "translate(668 1077)",
    fill: "#136ad0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5995",
    "data-name": "Group 5995",
    transform: "translate(-668 -1077)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5643",
    "data-name": "Path 5643",
    d: "M682.823,1088.71a.336.336,0,0,1,.125.12.322.322,0,0,1,.044.17.332.332,0,0,1-.027.15.517.517,0,0,1-.093.12l-5.372,2.68a.335.335,0,0,1-.167.05.325.325,0,0,1-.166-.05.333.333,0,0,1-.122-.12.342.342,0,0,1-.045-.17v-5.32a.322.322,0,0,1,.044-.17.331.331,0,0,1,.124-.12.223.223,0,0,1,.157-.04.452.452,0,0,1,.228.06ZM692,1082v14a5.012,5.012,0,0,1-5,5H673a5.012,5.012,0,0,1-5-5v-14a5.012,5.012,0,0,1,5-5h14a5.012,5.012,0,0,1,5,5Zm-7.008,7a2.336,2.336,0,0,0-1.226-2.06l-5.278-2.63a2.388,2.388,0,0,0-1.168-.31,2.287,2.287,0,0,0-1.167.32,2.311,2.311,0,0,0-.853.85,2.356,2.356,0,0,0-.312,1.17v5.32a2.333,2.333,0,0,0,.309,1.17,2.309,2.309,0,0,0,.855.85,2.353,2.353,0,0,0,1.186.32,2.119,2.119,0,0,0,1.1-.28l5.376-2.69a2.334,2.334,0,0,0,1.178-2.03Z",
    fill: "#136ad0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.92b379bedae025e748223b4194ca4130.svg";
export { ForwardRef as ReactComponent };